var _g, _path, _path2, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 114,
    viewBox: "0 0 128 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_18498_35208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.3666 25.1211C77.1851 25.1211 68.9219 33.4644 68.9219 43.7405C68.9219 54.0202 77.1851 62.3598 87.3666 62.3598C97.5665 62.3598 105.811 54.0202 105.811 43.7405C105.811 33.4644 97.5665 25.1211 87.3666 25.1211Z",
    fill: "#0062FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 62.1869C0.5 34.4594 22.7955 11.9546 50.2564 11.9546C77.7673 11.9546 100.013 34.4591 100.013 62.1869C100.013 89.9248 77.7673 112.419 50.2564 112.419C22.7954 112.419 0.5 89.9245 0.5 62.1869Z",
    fill: "#3EA0FE",
    fillOpacity: 0.35,
    stroke: "url(#paint0_linear_18498_35208)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7695 12.966C69.5575 7.36286 78.2298 4 87.6753 4C109.455 4 127.06 21.8154 127.06 43.7576C127.06 62.6048 114.081 78.3977 96.6236 82.4862C99.3125 76.2702 100.803 69.4052 100.803 62.1893C100.803 38.4383 84.6387 18.4766 62.7695 12.966Z",
    fill: "#4096FE"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_18498_35208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.3329 82.2172C99.0218 76.0012 100.513 69.1362 100.513 61.9203C100.513 38.1694 84.348 18.2077 62.4789 12.697C53.6431 19.9904 48 31.0796 48 43.4886C48 65.4388 65.6443 83.2462 87.3846 83.2462C90.4635 83.2462 93.4589 82.8903 96.3329 82.2172Z",
    fill: "#4096FE"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_18498_35208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.8472 38.7878C47.4973 38.7878 45.5391 40.8125 45.5391 43.231V65.5478C45.5391 67.9764 47.4973 69.9405 49.8472 69.9405C52.1971 69.9405 54.1064 67.9764 54.1064 65.5478V43.231C54.1064 40.8125 52.1971 38.7878 49.8472 38.7878Z",
    fill: "url(#paint1_linear_18498_35208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5871 81.5568C45.5871 83.9803 47.4964 86 49.8952 86C52.2451 86 54.1544 83.9803 54.1544 81.5568C54.1544 79.1332 52.2451 77.1641 49.8463 77.1641C47.4964 77.1641 45.5871 79.1332 45.5871 81.5568Z",
    fill: "url(#paint2_linear_18498_35208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7391 43.231C45.7391 40.917 47.6137 38.9878 49.8472 38.9878C52.0778 38.9878 53.9064 40.9139 53.9064 43.231V65.5478C53.9064 67.8717 52.081 69.7405 49.8472 69.7405C47.6105 69.7405 45.7391 67.8687 45.7391 65.5478V43.231ZM49.8952 85.8C47.6141 85.8 45.7871 83.8772 45.7871 81.5568C45.7871 79.2378 47.6126 77.3641 49.8463 77.3641C52.1304 77.3641 53.9544 79.2393 53.9544 81.5568C53.9544 83.8788 52.126 85.8 49.8952 85.8Z",
    stroke: "url(#paint3_linear_18498_35208)",
    strokeWidth: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_18498_35208",
    x: 50.9219,
    y: 7.12109,
    width: 72.8906,
    height: 73.2388,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9,
    result: "effect1_foregroundBlur_18498_35208"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_18498_35208",
    x: 36,
    y: 0.697021,
    width: 76.5117,
    height: 94.5491,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_18498_35208"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_18498_35208",
    x: 40.5391,
    y: 33.7878,
    width: 28.6172,
    height: 67.2122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.25098 0 0 0 0 0.588235 0 0 0 0 0.996078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18498_35208"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18498_35208",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18498_35208",
    x1: 16,
    y1: 23.2754,
    x2: 80.8496,
    y2: 102.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18498_35208",
    x1: 49.8477,
    y1: 41.4509,
    x2: 41.916,
    y2: 40.8437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18498_35208",
    x1: 49.8477,
    y1: 41.4509,
    x2: 41.916,
    y2: 40.8437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18498_35208",
    x1: 46.9105,
    y1: 44.2881,
    x2: 60.1595,
    y2: 47.2825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.f5f67a9e0ef26b3d86564105299ed354.svg";
export { ForwardRef as ReactComponent };